import { render, staticRenderFns } from "./Literacy.vue?vue&type=template&id=7547891d&scoped=true&"
import script from "./Literacy.vue?vue&type=script&lang=js&"
export * from "./Literacy.vue?vue&type=script&lang=js&"
import style0 from "./Literacy.vue?vue&type=style&index=0&id=7547891d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7547891d",
  null
  
)

export default component.exports